import React, { useState, useEffect } from "react";
import "../../../styles/desktop/config.css"; // Estilização para os switches

import getCondominioData from "../../../API/server/getCondominios";
import updateCondominio from "../../../API/Manager/responsaveisUser"; // Função para atualizar a configuração no servidor
import {checkAdmin} from "../../../API/server/adminVerify"; // Função para verificar se o usuário é admin

export default function Configuracoes({ onBack }) {
    const [isAcionamentosActive, setIsAcionamentosActive] = useState(false);
    const [isDispositivosActive, setIsDispositivosActive] = useState(false);
    const [isAlarmesActive, setIsAlarmesActive] = useState(false);
    const [condominioNome, setCondominioNome] = useState(null); // ID do condomínio

    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [telefone, setTelefone] = useState("");

    const [destinatarios] = useState([]); // Armazena os destinatários como vetor
    const [isAdmin, setIsAdmin] = useState(true); // Verifica se o usuário é admin

    // Verificação de admin ao montar o componente
    useEffect(() => {
        const checkUserAdmin = async () => {
            const user = JSON.parse(sessionStorage.getItem("user"));
            console.log(user.user)
            const result = await checkAdmin(user.user);
            setIsAdmin(result);
        };

        checkUserAdmin();
    }, []);

    // Função para carregar os dados do condomínio
    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await getCondominioData();
                console.log("Dados do condomínio:", data);
                setIsAcionamentosActive(data.condominio.config.acionamentos || false);
                setIsDispositivosActive(data.condominio.config.dispositivos || false);
                setIsAlarmesActive(data.condominio.config.alarmes || false);
                setCondominioNome(data.condominio.name); // Salva o ID do condomínio

                if (data.condominio.config.destinatarios && Array.isArray(data.condominio.config.destinatarios) && data.condominio.config.destinatarios.length > 0) {
                    const { nome, email, telefone } = data.condominio.config.destinatarios[0];
                    setNome(nome || "");
                    setEmail(email || "");
                    setTelefone(telefone || "");
                }
            } catch (error) {
                console.error("Erro ao buscar dados do condomínio:", error);
            }
        };

        fetchData();
    }, []); // Executa apenas na montagem do componente

    // Função para atualizar as configurações no servidor
    const updateConfig = async (config) => {
        try {
            await updateCondominio({
                nome: condominioNome,
                config,
            });
        } catch (error) {
            console.error("Erro ao atualizar configurações no servidor:", error);
        }
    };

    // Função para salvar ao clicar em Voltar
    const handleBack = () => {
        const config = {
            acionamentos: isAcionamentosActive,
            dispositivos: isDispositivosActive,
            alarmes: isAlarmesActive,
            destinatarios: [...destinatarios, { nome, email, telefone }],
        };
        updateConfig(config);
        onBack();
    };

    // Handlers para alternar os switches
    const handleToggleAcionamentos = () => {
        setIsAcionamentosActive((prev) => !prev);
    };

    const handleToggleDispositivos = () => {
        setIsDispositivosActive((prev) => !prev);
    };

    const handleToggleAlarmes = () => {
        setIsAlarmesActive((prev) => !prev);
    };

    return (
        <div className="ConfiguracoesContent">
            {!isAdmin && (
                <div className="noAuthorizationOverlay">
                    <p>Você não tem autorização para acessar esta página.</p>
                </div>
            )}
            <button className="config-btnVoltar" onClick={handleBack}>
                Voltar
            </button>
            <div className={`configContent ${!isAdmin ? "disabled" : ""}`}>
                <h1 className="configTitle">Configuração</h1>
                <div className="configObjeto">
                    <h1 className="objetoTitle">Notificações Automáticas</h1>

                    {/* Switch para Acionamentos */}
                    <div className="switchContainer">
                        <label className="switch">
                            <input
                                type="checkbox"
                                checked={isAcionamentosActive}
                                onChange={handleToggleAcionamentos}
                                disabled={!isAdmin}
                            />
                            <span className="slider"></span>
                        </label>
                        <span className="switchLabel">Acionamentos</span>
                    </div>

                    {/* Switch para Dispositivos */}
                    <div className="switchContainer">
                        <label className="switch">
                            <input
                                type="checkbox"
                                checked={isDispositivosActive}
                                onChange={handleToggleDispositivos}
                                disabled={!isAdmin}
                            />
                            <span className="slider"></span>
                        </label>
                        <span className="switchLabel">Dispositivos</span>
                    </div>

                    {/* Switch para Alarmes */}
                    <div className="switchContainer">
                        <label className="switch">
                            <input
                                type="checkbox"
                                checked={isAlarmesActive}
                                onChange={handleToggleAlarmes}
                                disabled={!isAdmin}
                            />
                            <span className="slider"></span>
                        </label>
                        <span className="switchLabel">Alarmes</span>
                    </div>

                    {/* Linha divisória */}
                    <hr className="divider" />

                    {/* Campo para Destinatário */}
                    <div className="destinatarioContainer">
                        <h1 className="objetoTitle-destinatario">Destinatário</h1>

                        <div className="inputGroup">
                            <label htmlFor="nome">Nome</label>
                            <input
                                className="inputConfig"
                                id="nome"
                                placeholder="Nome Completo"
                                value={nome}
                                onChange={(e) => setNome(e.target.value)}
                                disabled={!isAdmin}
                            />
                        </div>

                        <div className="inputGroup">
                            <label htmlFor="email">E-mail</label>
                            <input
                                className="inputConfig"
                                type="email"
                                id="email"
                                placeholder="exemplo@dominio.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                disabled={!isAdmin}
                            />
                        </div>

                        <div className="inputGroup">
                            <label htmlFor="telefone">Telefone</label>
                            <input
                                className="inputConfig"
                                id="telefone"
                                placeholder="43988887777"
                                value={telefone}
                                onChange={(e) => setTelefone(e.target.value)}
                                disabled={!isAdmin}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

// Por que deus nos abandonou?